import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import Page from '../../../../layout/Page/Page';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import { demoPages } from '../../../../menu';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import Button from '../../../../components/bootstrap/Button';
import ModalRegisterPrinters from '../../../../components/modals/Printers/ModalRegister';
import { DefaultContext } from '../../../../contexts/default';
import PrinterDB from '../../../../database/wrappers/printer';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import showNotification from '../../../../components/extras/showNotification';
import notificationBody from '../../../../helpers/utils/functions/notificationBody';
import { orderBy } from 'firebase/firestore';
import SelectStore from '../../../../components/MyCustom/SelectStore';
import useDarkMode from '../../../../hooks/useDarkMode';
import ModalTestPrinters from '../../../../components/modals/Printers/ModalTestPrinter';

const Printers = () => {
    const { darkModeStatus } = useDarkMode();

    const { establishment, store, onShowAlert, onShowQuestion } = useContext(DefaultContext);

    const [openModalTest, setOpenModalTest] = useState(false);
    const [openModalRegister, setOpenModalRegister] = useState(false);
    const [printers, setPrinters] = useState([]);
    const [PrintersSelected, setPrintersSelected] = useState(null);

    useEffect(() => {
        if (!establishment || !store) return;
        const onSubscribe = new PrinterDB(establishment.id, store.id).on(setPrinters, orderBy('name', 'asc'));
        return onSubscribe;
    }, [establishment, store])

    const handleOpenModalRegister = useCallback(() => {
        setPrintersSelected(null)
        setOpenModalRegister(true);
    }, [])

    const handleCloseModalRegister = useCallback(() => {
        setOpenModalRegister(false);
    }, [])

    const handleOpenModalEdit = useCallback((item) => {
        setPrintersSelected(item);
        setOpenModalRegister(true)
    }, [])

    const handleOpenModalDelete = useCallback((id) => {
        onShowQuestion({
            title: 'Exclusão de Impressora',
            message: 'Você está excluindo uma impressora. Está ação é irreversível. Deseja continuar?',
            onConfirm: () => {
                new PrinterDB(establishment.id)
                    .delete(id)
                    .then(res => showNotification('', notificationBody('Registro deletado com sucesso'), 'success'))
                    .catch(err => showNotification('', notificationBody('Falhou ao deletar o registro'), 'danger'))
            }
        })
    }, [])

    const handleOpenModalTest = useCallback((item) => {
        setPrintersSelected(item);
        setOpenModalTest(true)
    }, [])

    const handleChangeStatus = useCallback((id, active) => {
        new PrinterDB(establishment.id, store.id)
            .update(id, {
                active: !active
            })
            .catch(error => onShowAlert({
                title: 'ERRO!',
                msm: 'Não foi possível atualizar o status do produto',
                icon: 'Error',
                color: 'danger'
            }))
    }, [establishment, store])

    const columns = useMemo(() => ([
        {
            label: 'Nome',
            field: 'name',
        },
        {
            label: 'QTD. Produtos',
            field: 'products',
            format: row => row.products.length,
            formatExport: value => value.length
        },
        {
            label: 'Status',
            field: 'active',
            format: row => (
                <Button
                    isLink
                    color={row.active ? 'success' : 'danger'}
                    icon='Circle'
                    onClick={() => handleChangeStatus(row.id, row.active)}
                    className='text-nowrap'>
                    {row.active ? 'Ativo' : 'Inativo'}
                </Button>
            ),
            formatExport: value => value ? 'Ativo' : 'Inativo'
        },
        {
            label: 'Ações',
            field: 'actions',
            format: row => (
                <div className='w-25 d-flex justify-content-between'>
                    <Button
                        color={darkModeStatus ? 'light' : 'dark'}
                        icon="edit"
                        shadow="sm"
                        hoverShadow="sm"
                        size="sm"
                        onClick={() => handleOpenModalEdit(row)}
                    />

                    <Button
                        className='ms-2'
                        color={darkModeStatus ? 'light' : 'dark'}
                        icon="Print"
                        shadow="sm"
                        hoverShadow="sm"
                        size="sm"
                        onClick={() => handleOpenModalTest(row)}
                    />

                    <Button
                        className='ms-2'
                        color="danger"
                        icon="Trash"
                        shadow="sm"
                        hoverShadow="sm"
                        size="sm"
                        onClick={() => handleOpenModalDelete(row.id)}
                    />
                </div>
            ),
            noExport: true,
        },
    ]), [handleChangeStatus, handleOpenModalEdit, handleOpenModalDelete])

    return (
        <>
            <PageWrapper title={demoPages.store.subMenu.printers.text}>
                <SubHeader>
                    <SubHeaderLeft>
                        <Breadcrumb
                            list={[
                                { title: 'Loja', to: '/store/printers' },
                                {
                                    title: 'Impressoras',
                                    to: '/store/printers',
                                },
                            ]}
                        />
                    </SubHeaderLeft>
                    <SubHeaderRight>
                        <Button
                            color='primary'
                            icon='plus'
                            shadow="sm"
                            hoverShadow="sm"
                            onClick={handleOpenModalRegister}
                        >
                            Cadastrar
                        </Button>
                    </SubHeaderRight>
                </SubHeader>
                <Page container="flui">
                    <Card>
                        <CardBody className='table-responsive'>
                            <div className='row d-flex align-items-center mt-4 mx-1' >
                                <SelectEstablishment />
                                <SelectStore />
                            </div>

                            <TableCustom columns={columns} rows={printers} fileName={'Impressoras'} />
                        </CardBody>
                    </Card>
                </Page>
            </PageWrapper>

            <ModalRegisterPrinters
                open={openModalRegister}
                setIsOpen={setOpenModalRegister}
                setIsClose={handleCloseModalRegister}
                printersSelected={PrintersSelected}
            />

            <ModalTestPrinters
                open={openModalTest}
                setIsOpen={setOpenModalTest}
                printersSelected={PrintersSelected}
            />
        </>
    );
};

export default Printers;
